<template lang="pug" src="./navigation-mobile.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      active: false
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/navigation-mobile/navigation-mobile.vue